import { useState } from "react"

import workIcon from '../../assets/icons/workIcon.png';
import homeIcon from '../../assets/icons/homeIcon.png';
import pythonIcon from '../../assets/icons/pythonIcon.png';
import cppIcon from '../../assets/icons/cppIcon.png';
import csharpIcon from '../../assets/icons/csharpIcon.png';
import javascriptIcon from '../../assets/icons/javascriptIcon.png';
import typescriptIcon from '../../assets/icons/typescriptIcon.png';
import reactIcon from '../../assets/icons/reactIcon.svg';
import wordpressIcon from '../../assets/icons/wordpressIcon.png';
import htmlIcon from '../../assets/icons/htmlIcon.png';
import cssIcon from '../../assets/icons/cssIcon.png';
import webdevIcon from '../../assets/icons/webdevIcon.png';
import ladderIcon from '../../assets/icons/ladderIcon.png';
import stIcon from '../../assets/icons/structuredtextIcon.png';
import bootstrapIcon from '../../assets/icons/bootstrapIcon.png';
import brIcon from '../../assets/icons/brIcon.png';
import plcIcon from '../../assets/icons/plcIcon.png';
import linuxIcon from '../../assets/icons/linuxIcon.png';
import gamedevIcon from '../../assets/icons/gamedevIcon.png';
import codesysIcon from '../../assets/icons/codesysIcon.png';
import arduinoIcon from '../../assets/icons/arduinoIcon.png';
import altiumIcon from '../../assets/icons/altiumIcon.png';
import solidworksIcon from '../../assets/icons/solidworksIcon.png';
import printingIcon from '../../assets/icons/printingIcon.png';
import electronicsIcon from '../../assets/icons/electronicsIcon.png';
import turckIcon from '../../assets/icons/turckIcon.ico';
import panasonicIcon from '../../assets/icons/panasonicIcon.png';
import fpwinIcon from '../../assets/icons/fpwinIcon.png';
import hmwinIcon from '../../assets/icons/hmwinIcon.png';
import pandasIcon from '../../assets/icons/pandasIcon.png';
import matplotlibIcon from '../../assets/icons/matplotlibIcon.png';
import tensorflowIcon from '../../assets/icons/tensorflowIcon.png';
import noderedIcon from '../../assets/icons/noderedIcon.png';
import mqttIcon from '../../assets/icons/mqttIcon.png';
import dockerIcon from '../../assets/icons/dockerIcon.png';
import j1939Icon from '../../assets/icons/Excavator.png';
import kicadIcon from '../../assets/icons/kicadIcon.png';
import tractorIcon from '../../assets/icons/tractorIcon.png';
import nextjsIcon from '../../assets/icons/nextjsIcon.png';
import tailwindIcon from '../../assets/icons/tailwindIcon.png';
import scikitLearnIcon from '../../assets/icons/scikitLearnIcon.png';
import qtIcon from '../../assets/icons/qtIcon.png';
import jenkinsIcon from '../../assets/icons/jenkinsIcon.png';
import terraformIcon from '../../assets/icons/terraformIcon.png';
import awsIcon from '../../assets/icons/awsIcon.png';
import helmIcon from '../../assets/icons/helmIcon.png';
import kubernetesIcon from '../../assets/icons/kubernetesIcon.png';
import grafanaIcon from '../../assets/icons/grafanaIcon.png';


const ButtonFilter = ({name, icon, activeFilter, handleClickFilter}) => {

  let isActive = (activeFilter===name)

  return(
      <button className={`lg:text-base min-w-[100px]
                          h-8 px-1 text-xs
                          overflow-hidden
                          flex flex-row
                          border border-solid border-dark rounded-xl
                          transition-colors duration-200
                          ${isActive ? "bg-primary text-light" : "bg-light text-dark"}`}
              onClick={() => handleClickFilter(name)}>
          
          {icon &&
            <img src={icon} alt={name+" logo"} height="25px" width="25px"
                 className="object-contain pr-1"/>}
          
          <div className="w-full m-auto">{name}</div>
          
      </button>
  )
}


// Just a black line
const Separator = () => {
  return (
    <div className="h-8 lg:h-10
                    border border-solid border-dark
                    mx-0 lg:mx-4
                    hidden sm:block">
    </div>
  )
}



const CategoryHeader = ({title}) => {
  return (
    <h3 className="text-xl w-36">{title}</h3>
  )
}




const ButtonFilters = ({projects, setFilteredProjects}) => {

  const [activeFilter, setActiveFilter] = useState('All');


  const handleClickFilter = (name) => {
    // Update the current filter
    setActiveFilter(name);

    // Update the shown projects according to the new filter
    const filteredProjects = projects.filter(project => project.tags.includes(name));

    if (name==="All") setFilteredProjects(projects);
    else              setFilteredProjects(filteredProjects);
  }




  return (
    <div className="w-full md:w-3/4 m-auto flex flex-col justify-center gap-4 mt-4">

      <div className="flex flex-col sm:flex-row justify-center w-full gap-2">
        <div className="flex flex-row justify-center">
          <ButtonFilter name="All"             activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
        </div>
        <Separator />
        <div className="flex flex-row justify-center gap-2">
          <ButtonFilter name="Professional"    icon={workIcon}       activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
          <ButtonFilter name="Personal"        icon={homeIcon}       activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
        </div>
      </div>
 
      <div className="flex flex-col justify-center gap-4">
        
        <div className="flex flex-row items-center gap-2 px-2 bg-light rounded-2xl">
          <CategoryHeader title="WebDev" />
          <div className="flex flex-row flex-wrap items-center gap-2 p-2">
            <ButtonFilter name="WebDev"          icon={webdevIcon}      activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="React.js"        icon={reactIcon}       activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="Next.js"         icon={nextjsIcon}      activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="JavaScript"      icon={javascriptIcon}  activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="TypeScript"      icon={typescriptIcon}  activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="HTML"            icon={htmlIcon}        activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="CSS"             icon={cssIcon}         activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="Tailwind"        icon={tailwindIcon}    activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="Bootstrap"       icon={bootstrapIcon}   activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="Wordpress"       icon={wordpressIcon}   activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
          </div>
        </div>

        <div className="flex flex-row items-center gap-2 px-2 bg-light rounded-2xl">
          <CategoryHeader title="Development" />
          <div className="flex flex-row flex-wrap items-center gap-2 p-2">
            <ButtonFilter name="C++"             icon={cppIcon}         activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="C#"              icon={csharpIcon}      activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="Python"          icon={pythonIcon}      activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="Qt"              icon={qtIcon}          activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="GameDev"         icon={gamedevIcon}     activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
          </div>
        </div>

        <div className="flex flex-row items-center gap-2 px-2 bg-light rounded-2xl">
          <CategoryHeader title="DevOps" />
          <div className="flex flex-row flex-wrap items-center gap-2 p-2">
            <ButtonFilter name="AWS"             icon={awsIcon}         activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="Linux"           icon={linuxIcon}       activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="Kubernetes"      icon={kubernetesIcon}  activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="Docker"          icon={dockerIcon}      activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="Jenkins"         icon={jenkinsIcon}     activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="Terraform"       icon={terraformIcon}   activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="Helm"            icon={helmIcon}        activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="Grafana"         icon={grafanaIcon}     activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
          </div>
        </div>

        <div className="flex flex-row items-center gap-2 px-2 bg-light rounded-2xl">
          <CategoryHeader title="Data Science" />
          <div className="flex flex-row flex-wrap items-center gap-2 p-2">
            <ButtonFilter name="Pandas"          icon={pandasIcon}         activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="Matplotlib"      icon={matplotlibIcon}     activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="scikit-learn"    icon={scikitLearnIcon}    activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="Tensorflow"      icon={tensorflowIcon}     activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="Node-RED"        icon={noderedIcon}        activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="MQTT"            icon={mqttIcon}           activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
          </div>
        </div>

        <div className="flex flex-row items-center gap-2 px-2 bg-light rounded-2xl">
          <CategoryHeader title="Mechatronics" />
          <div className="flex flex-row flex-wrap items-center gap-2 p-2">
            <ButtonFilter name="PLC"             icon={plcIcon}         activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="B&R"             icon={brIcon}          activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="Codesys"         icon={codesysIcon}     activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="ST"              icon={stIcon}          activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="Ladder"          icon={ladderIcon}      activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="Turck"           icon={turckIcon}       activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="Panasonic"       icon={panasonicIcon}   activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="FPWIN"           icon={fpwinIcon}       activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="HMWIN"           icon={hmwinIcon}       activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="TX Visu Pro"      icon={turckIcon}      activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="J1939"           icon={j1939Icon}       activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="ISOBUS"          icon={tractorIcon}     activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="SolidWorks"      icon={solidworksIcon}  activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="3D printing"     icon={printingIcon}    activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
          </div>
        </div>

        <div className="flex flex-row items-center gap-2 px-2 bg-light rounded-2xl">
          <CategoryHeader title="Electronics" />
          <div className="flex flex-row flex-wrap items-center gap-2 p-2">
            <ButtonFilter name="Electronics"     icon={electronicsIcon} activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="Arduino"         icon={arduinoIcon}     activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="Altium"          icon={altiumIcon}      activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
            <ButtonFilter name="KiCAD"           icon={kicadIcon}       activeFilter={activeFilter} handleClickFilter={handleClickFilter} />
          </div>
        </div>

      </div>

      {(activeFilter === 'All') ? 
      <p>Click on any skill to show only related projects.</p> :
      <p>Showing all projects with the '{activeFilter}' tag:</p>}

    </div>
  )
}

export default ButtonFilters